import { useAsync } from '@nxsys/hooks/useAsync';
import { getUrgentActionsSummaryApi } from '@nxsys/services/api/urgentActions';
import { UrgentActionsSummaryResponse } from '@nxsys/types/api/urgentActions';
import { showMessage } from '@nxsys/utils/message';
import { useEffect } from 'react';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

export const useUrgentActionsSummary = () => {
  const { value, loading, error, run } = useAsync<
    UrgentActionsSummaryResponse,
    void
  >(getUrgentActionsSummaryApi);

  useEffect(() => {
    if (error) {
      showMessage({ type: 'error', content: getErrorMessage(error) });
    }
  }, [error]);

  return { value, loading, error, run };
};
